/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  margin-top: calc(9rem/14);
  height: calc(46rem/14);
  min-width: calc(150rem/14);
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host > .container {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
  border: 1px solid var(--davinci-color-outline,#B4BEC5);
  height: 100%;
  width: 100%;
  position: relative;
  padding: 0 calc(12rem/14) 0 calc(14rem/14);
}
:host > .container > input {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  align-self: auto;
  display: none;
  border: none;
  height: 100%;
  font-size: inherit;
}
:host > .container > input::-ms-clear {
  display: none;
}
:host > .container > input:focus {
  outline: none;
}
:host > .container > label {
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  font-size: inherit;
  left: 0;
  top: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  -webkit-transform-origin: left top;
          transform-origin: left top;
  -webkit-transform: translate(0, -50%);
          transform: translate(0, -50%);
  font-size: calc(12rem/14);
  line-height: calc(18rem/14);
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
  padding: 0 calc(6rem/14);
  margin-left: calc(10rem/14);
  font-weight: 600;
  max-width: 90%;
}
:host > .container > davinci-spinner {
  display: none;
  -webkit-box-flex: 0;
          flex: 0 0 auto;
}
:host > .container > div.currentvalue {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  align-self: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host > .container > div.currentvalue slot::slotted(*),
:host > .container > div.currentvalue ::slotted(*) {
  cursor: pointer;
  font-size: inherit;
}
:host > .container > davinci-icon-ref {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  align-self: auto;
  width: calc(24rem/14);
  height: calc(24rem/14);
  cursor: pointer;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host > .container > .overlaywrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  z-index: 20;
}
:host > .container > .overlaywrapper > .list {
  z-index: 8;
  position: fixed;
  max-height: calc(300rem/14);
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-y: auto;
  border: 1px solid var(--davinci-color-outline,#B4BEC5);
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
  display: none;
}
:host > .container.expanded > .overlaywrapper > .list, :host > .container.expanded > .overlaywrapper {
  display: block;
}
:host > .container.placeholder > div.currentvalue {
  color: #697987;
  color: var(--davinci-color-text-lighter, #697987);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) > .container {
  border-color: #D2D9DD;
  border-color: var(--davinci-color-outline-disabled, #D2D9DD);
}
:host([disabled]) > .container > div {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) > .container > davinci-icon-ref {
  fill: #8999A4;
  fill: var(--davinci-color-text-disabled, #8999A4);
}

:host([editable]) > .container > input {
  display: block;
}
:host([editable]) > .container > div {
  display: none;
}

:host(:focus) {
  outline: none;
}

:host([label=""]) > .container > label,
:host(:not([label])) > .container > label {
  display: none;
}

:host([loading]) > .container > davinci-spinner {
  display: block;
}`;
export { style };
//# sourceMappingURL=DropDown.style.js.map